/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

export type ApiEvidenceV1SiteMaterialSamplesEvidenceListType = typeof ApiEvidenceV1SiteMaterialSamplesEvidenceListType[keyof typeof ApiEvidenceV1SiteMaterialSamplesEvidenceListType];


export const ApiEvidenceV1SiteMaterialSamplesEvidenceListType = {
  AS: 'AS',
  BP: 'BP',
  EU: 'EU',
  LFR: 'LFR',
  LP: 'LP',
  MP: 'MP',
  MS: 'MS',
  O: 'O',
  SB: 'SB',
  SP: 'SP',
  SS: 'SS',
  UP: 'UP',
} as const;
